<script lang="ts">
import type { StudyEmergingPipelineSlideProps } from '$lib/components/study/slide-layout-types'
import StudyBlueCalloutCard from '../cards/StudyBlueCalloutCard.svelte'
import StudyPipelineSnapshotTableCard from '../cards/StudyPipelineSnapshotTableCard.svelte'
import StudyTealPanelCalloutCard from '../cards/StudyTealPanelCalloutCard.svelte'
import StudySlide from '../StudySlide.svelte'
import StudySlideContent from '../StudySlideContent.svelte'

/** China / emerging pipeline panel + table + IMX lens + disclaimer (`s8b`). */
let props: StudyEmergingPipelineSlideProps = $props()

const headlineStyle = props.headlineStyle ?? 'margin-bottom:.75rem;'
const tcStyle = props.tcStyle ?? 'gap:1.15rem;align-items:start;'
const discStyle =
  props.disclaimerStyle ??
  'margin:.85rem 0 0;font-size:.72rem;line-height:1.45;color:var(--mu);opacity:.9;'
</script>

<StudySlide
  id={props.id}
  active={props.active}
  extraBottom={props.extraBottom}
  background={props.background}
  slideClass={props.slideClass}
>
  <StudySlideContent
    maxWidth={props.maxWidth ?? '980px'}
    contentClass={props.contentClass}
    style={props.contentStyle}
  >
    <div class="ey">{@html props.eyebrow}</div>
    <div class="hl" style={headlineStyle}>{@html props.headline}</div>
    <div class="tc" style={tcStyle}>
      <StudyTealPanelCalloutCard
        eyebrowHtml={props.panelEyebrowHtml}
        bodyHtml={props.panelBodyHtml}
      />
      <StudyPipelineSnapshotTableCard headers={props.pipelineHeaders} rows={props.pipelineRows} />
    </div>
    <StudyBlueCalloutCard
      bodyHtml={props.imxLensHtml}
      cardStyle={props.imxLensCardStyle ?? 'margin-top:.85rem;'}
      paragraphStyle={props.imxLensParagraphStyle ?? 'margin:0;font-size:.86rem;line-height:1.5;'}
    />
    <p style={discStyle}>{@html props.disclaimerHtml}</p>
  </StudySlideContent>
</StudySlide>
